import * as React from 'react'

import { Box, Circle, Tag, Text } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { strategyColor, strategyTranslation } from 'modules/performance_process/lib/reviewStrategy'

import * as styles from './index.vanilla.css'

type Props = {
  currentStrategy: PerformanceReviewerStrategiesStrategyEnum
  strategies: PerformanceReviewerStrategiesStrategyEnum[]
}

const SAMPLE_SCORE: Record<PerformanceReviewerStrategiesStrategyEnum, string> = {
  self: '3/5',
  manager: '5/5',
  peers: '3/5',
  direct_reports: '5/5',
}

const NEW_SCORE = '4/5'

export const NewScoreCard: React.FC<Props> = ({ currentStrategy, strategies }) => {
  return (
    <Box className={styles.base}>
      <Text.Normal weight="semibold" color="grey1000">
        {i18n.t('performance_process.score_strategy_weights.score_card.title')}
      </Text.Normal>

      <Box flexDirection="column" gap="s4">
        {strategies.map((strategy) => {
          const isStrategy = strategy === currentStrategy
          return (
            <Box key={strategy} gap="s4" flexDirection="row" justifyContent="spaceBetween">
              <Box flexDirection="row" alignItems="center" gap="s8">
                <Box flexDirection="row">
                  <Circle color={strategyColor(strategy)[1]} size={12} />
                </Box>
                {isStrategy ? (
                  <Text.Normal color="grey800" size="100">
                    {`${strategyTranslation(strategy)} · 0%`}
                  </Text.Normal>
                ) : (
                  <Box className={styles.strategyPlaceholder} />
                )}
              </Box>
              <Box flexDirection="row" gap="s8" alignItems="center">
                {isStrategy && (
                  <Tag type="lime">
                    {i18n.t('performance_process.score_strategy_weights.score_card.new')}
                  </Tag>
                )}
                <Text.Normal size="200" weight="semibold" color="grey1000">
                  {isStrategy ? NEW_SCORE : SAMPLE_SCORE[strategy]}
                </Text.Normal>
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
